<x-subscriber-agreement
  *ngFor="let agreement of agreements; trackBy: 'id' | trackBy"
  [agreement]="agreement"
></x-subscriber-agreement>
